'use strict'


export default function LoginReducer(state = {}, action) {
	switch (action.type) {
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/login/reducers/LoginReducer.js